import LoginPage from "@/authorization/pages/LoginPage";
import { routerMiddleware } from "@/_shared/middlewares";

const routes = [
  {
    path: "/login",
    component: LoginPage,
    beforeEnter: routerMiddleware.anonymousUsersOnly,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/authorization/routes.js